import { useEffect } from 'react';
import { Location, useLocation, useNavigate, useParams } from 'react-router-dom';

import { updateAttendance } from '../api/ElkEventService';
import { useUserContext } from '../contexts/UserContext';
import { useEventCacheContext } from '../contexts/EventCacheContext';

export interface UpdateAttendanceUserActionState {
  inviteeUuid?: string;
  token?: string;
  showPhotosPromo?: boolean;
}

const UpdateAttendeeUserAction = () => {
  const userContext = useUserContext();
  const eventCacheContext = useEventCacheContext();
  const location = useLocation() as Location<UpdateAttendanceUserActionState>;
  const navigate = useNavigate();
  const { eventId } = useParams();

  const inviteeUuid = location.state?.inviteeUuid;
  const token = location.state?.token;

  useEffect(() => {
    if (eventId !== undefined) {
      void fetchAndUpdate(eventId);
    }
  }, [eventId]);

  const fetchAndUpdate = async (eventId: string) => {
    const event = await eventCacheContext.fetchEvent({ eventId });

    const inviteeMe = event?.attendees.find((attendee) => attendee.inviteeId === inviteeUuid ?? '');
    if (inviteeMe && inviteeUuid && eventId) {
      inviteeMe.userId = userContext.id;

      await updateAttendance(userContext, eventId, inviteeMe, undefined, token, true);
    }

    navigate(`/event/${eventId}`);
  };

  return null;
};

export default UpdateAttendeeUserAction;
